import { render, staticRenderFns } from "./retention-data.vue?vue&type=template&id=793a94b2&scoped=true&"
import script from "./retention-data.vue?vue&type=script&lang=ts&"
export * from "./retention-data.vue?vue&type=script&lang=ts&"
import style0 from "./retention-data.vue?vue&type=style&index=0&id=793a94b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a94b2",
  null
  
)

export default component.exports